import { useState, useRef } from "react";

export const UseNetworkGraphCommentChart = (title, onPointClick = () => {}) => {
    const chartRef = useRef(null);
    const [tooltipData, setTooltipData] = useState(null);
    const tooltipRef = useRef();

    const [options, setOptions] = useState({
        chart: {
            type: "networkgraph",
            height: 700,
            animation: false,
            events: {
                load: function () {
                    chartRef.current = this;
                },
            },
        },
        title: {
            text: title,
            align: "center",
        },
        tooltip: {
            enabled: false,
        },
        plotOptions: {
            networkgraph: {
                keys: ["from", "to"],
                layoutAlgorithm: {
                    enableSimulation: false,
                    integration: "verlet",
                    approximation: "barnes-hut",
                    gravitationalConstant: 0.01,
                },
                draggable: false,
            },
            series: {
                animation: false,
                turboThreshold: 1,
            },
        },
        turboThreshold: 1,
        lang: {
            viewFullscreen: "Ver en pantalla completa",
            loading: "Cargando datos...", // 🔹 Mensaje del loading
            noData: "No hay datos para mostrar",
        },
        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ["viewFullscreen"],
                },
            },
        },
        series: [
            {
                point: {
                    events: {
                        click: function () {
                            onPointClick(this);
                        },
                    },
                },
                accessibility: {
                    enabled: false,
                },
                dataLabels: {
                    enabled: true,
                    linkFormat: "",
                },
                id: "reddit-graph",
            },
        ],
        credits: { enabled: false },
    });

    const showLoading = () => {
        if (chartRef.current) {
            chartRef.current.showLoading();
        }
    };

    const hideLoading = () => {
        if (chartRef.current) {
            chartRef.current.hideLoading();
        }
    };

    const handleCloseTooltip = () => setTooltipData(null);

    return {
        options,
        setOptions,
        showLoading,
        hideLoading,
        tooltipData,
        tooltipRef,
        setTooltipData,
        handleCloseTooltip,
        containerElement: chartRef.current?.container || null,
    };
};
